export {default as Delaunay} from "./delaunay.js";
export {default as Voronoi} from "./voronoi.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-delaunay/src/index.js
// module id = 912
// module chunks = 1